import { Link, useRouterState } from "@tanstack/react-router";
import { ChevronDown } from "lucide-react";
import { useState } from "react";
import { SiteMoreMenu, MORE_PATHS } from "./SiteMoreMenu";
import { SiteSwitcher } from "./SiteSwitcher";
interface TabDef {
  key: string;
  label: string;
  path: string;
}

const SITE_TABS: TabDef[] = [
  { key: "now", label: "Now", path: "now" },
  { key: "performance", label: "Performance", path: "performance" },
  { key: "blocks", label: "Blocks", path: "blocks" },
  { key: "sensors", label: "Meters & sensors", path: "sensors" },
  { key: "alerts", label: "Alerts", path: "alerts" },
  { key: "equipment", label: "Equipment", path: "equipment" },
];

interface SiteTabsProps {
  tenant: string;
  scope: string;
  site: string;
}

export function SiteTabs({ tenant, scope, site }: SiteTabsProps) {
  const [moreOpen, setMoreOpen] = useState(false);
  const pathname = useRouterState({ select: (s) => s.location.pathname });
  const basePath = `/t/${tenant}/s/${scope}/plants/${site}`;

  const isOnMorePage = MORE_PATHS.some((p) => pathname.startsWith(`${basePath}/${p}`));

  return (
    <div className="sitetabs">
      {SITE_TABS.map((tab) => {
        const href = `${basePath}/${tab.path}`;
        const active = pathname.startsWith(href);
        return (
          <Link key={tab.key} to={href as never} style={{ textDecoration: "none" }}>
            <span className={active ? "on" : ""}>{tab.label}</span>
          </Link>
        );
      })}

      <span
        className={`has-menu${isOnMorePage ? " on" : ""}`}
        onClick={() => setMoreOpen((v) => !v)}
        role="button"
        tabIndex={0}
        aria-expanded={moreOpen}
        aria-haspopup="menu"
        onKeyDown={(e) => {
          if (e.key === "Enter" || e.key === " ") {
            e.preventDefault();
            setMoreOpen((v) => !v);
          }
        }}
      >
        More <ChevronDown size={11} style={{ verticalAlign: "middle", display: "inline-block" }} />
      </span>
      {moreOpen && (
        <SiteMoreMenu basePath={basePath} onClose={() => setMoreOpen(false)} />
      )}

      <SiteSwitcher currentSite={site} tenant={tenant} scope={scope} />
    </div>
  );
}
